import { Allocation, ILicensableService, ILicenseAllowance } from '@module/license/models';
import { requestServerGet } from '@service/hardwareDataService';
import { requestAllocationDelete, requestAllocationGet, requestAllocationPost, requestAllocationPut, requestNewAllocationGet } from '@service/servicesDataService';
import * as hardwareActionCreators from '../actionCreators/hardwareActionCreators';

export const ALLOCATION_GET_REQUEST = 'SERVICE_GET_REQUEST';
export const ALLOCATION_GET_SUCCESS = 'SERVICE_GET_SUCCESS';
export const ALLOCATION_GET_ERROR = 'SERVICE_GET_ERROR';
export const ALLOCATION_NEW_REQUEST = 'ALLOCATION_NEW_REQUEST';
export const ALLOCATION_NEW_SUCCESS = 'ALLOCATION_NEW_SUCCESS';
export const ALLOCATION_NEW_ERROR = 'ALLOCATION_NEW_ERROR';
export const ALLOCATION_ADD_REQUEST = 'ALLOCATION_ADD_REQUEST';
export const ALLOCATION_ADD_SUCCESS = 'ALLOCATION_ADD_SUCCESS';
export const ALLOCATION_ADD_ERROR = 'ALLOCATION_ADD_ERROR';
export const ALLOCATION_UPDATE_REQUEST = 'ALLOCATION_UPDATE_REQUEST';
export const ALLOCATION_UPDATE_SUCCESS = 'ALLOCATION_UPDATE_SUCCESS';
export const ALLOCATION_UPDATE_ERROR = 'ALLOCATION_UPDATE_ERROR';
export const ALLOCATION_CANCEL_REQUEST = 'ALLOCATION_CANCEL_REQUEST';
export const ALLOCATION_DELETE_REQUEST = 'ALLOCATION_DELETE_REQUEST';
export const ALLOCATION_DELETE_SUCCESS = 'ALLOCATION_DELETE_SUCCESS';
export const ALLOCATION_DELETE_ERROR = 'ALLOCATION_DELETE_ERROR';
export const ALLOCATION_EDITABLE_ROW_ADD = 'ALLOCATION_EDITABLE_ROW_ADD';
export const ALLOCATION_EDIT_ROW = 'ALLOCATION_EDIT_ROW';
export const ALLOCATION_EDIT_ROW_SUCCESS = 'ALLOCATION_EDIT_ROW_SUCCESS';
export const ALLOCATION_RESET_CURRENTLY_EDITING = 'ALLOCATION_RESET_CURRENTLY_EDITING';
export const ALLOCATION_CANCEL_EDITING = 'ALLOCATION_CANCEL_EDITING';
export const ALLOCATION_CLEAR_ERROR = 'ALLOCATION_CLEAR_ERROR';

export function onAllocationGetRequest(siteId: number, accessToken: string) {
    return (dispatch: any) => {
        makeAllocationGetRequest(dispatch, siteId, accessToken);
    };
}

export function makeAllocationGetRequest(dispatch: any, siteId: number, accessToken: string) {
    dispatch({ type: ALLOCATION_GET_REQUEST });
    return requestAllocationGet(siteId, accessToken).then(
        (success: ILicenseAllowance[]) => {
            dispatch(onAllocationGetResponseSuccess(success));
        },
        error => {
            dispatch(onAllocationGetResponseError());
        }
    );
}

export function onAllocationGetResponseSuccess(siteInfo: any) {
    return {
        type: ALLOCATION_GET_SUCCESS,
        siteInfo
    };
}

export function onAllocationGetResponseError() {
    return {
        type: ALLOCATION_GET_ERROR,
        text: 'Error receiving data'
    };
}

export function onNewAllocationGetRequest(siteId: number, accessToken: string) {
    return (dispatch: any) => {
        makeNewAllocationGetRequest(dispatch, siteId, accessToken);
    };
}

export function makeNewAllocationGetRequest(dispatch: any, siteId: number, accessToken: string) {
    dispatch({ type: ALLOCATION_NEW_REQUEST });
    return requestNewAllocationGet(siteId, accessToken).then(
        (success: any) => {
            dispatch(onNewAllocationGetResponseSuccess(success));
        },
        error => {
            dispatch(onNewAllocationGetResponseError());
        }
    );
}

export function onNewAllocationGetResponseSuccess(serviceOptions: ILicenseAllowance[]) {
    return {
        type: ALLOCATION_NEW_SUCCESS,
        serviceOptions
    };
}

export function onNewAllocationGetResponseError() {
    return {
        type: ALLOCATION_NEW_ERROR,
        text: 'Error receiving data'
    };
}

export function onAddAllocation(allocation: ILicenseAllowance, accessToken: string) {
    return (dispatch: any) => {
        makeAllocationPostRequest(dispatch, allocation, accessToken);
    };
}

export function makeAllocationPostRequest(dispatch: any, allocation: ILicenseAllowance, accessToken: string) {
    dispatch({ type: ALLOCATION_ADD_REQUEST, allocation });
    return requestAllocationPost(allocation, accessToken).then(
        (success: ILicenseAllowance[]) => {
            dispatch({
                type: ALLOCATION_RESET_CURRENTLY_EDITING,
                success
            });
            dispatch(onAddAllocationResponseSuccess(success));
        },
        error =>
            dispatch(onAddAllocationResponseError())
    );
}

export function onAddAllocationResponseSuccess(allocation: ILicenseAllowance[]) {
    return {
        type: ALLOCATION_ADD_SUCCESS,
        allocation
    };
}

export function onAddAllocationResponseError() {
    return {
        type: ALLOCATION_ADD_ERROR,
        text: 'Error receiving data'
    };
}

export function onAddNewEditableRow(allocations: ILicenseAllowance[], siteId: number, accessToken: string) {
    return (dispatch: any) => {
        dispatch({
            type: ALLOCATION_RESET_CURRENTLY_EDITING,
            allocations
        });
        dispatch({
            type: ALLOCATION_EDITABLE_ROW_ADD,
            newAllocation: new Allocation(siteId)
        });
    };
}

export function onCancelAllocationEdit(allocation: ILicenseAllowance) {
    return (dispatch: any) => {
        dispatch({
            type: ALLOCATION_RESET_CURRENTLY_EDITING,
            allocation
        });
        dispatch({
            type: ALLOCATION_CANCEL_EDITING,
            allocation
        });
    };
}

export function onEditExistingRow(allocation: ILicenseAllowance, siteId: number, accessToken: string) {
    return (dispatch: any) => {
        dispatch({
            type: ALLOCATION_RESET_CURRENTLY_EDITING,
            allocation
        });
        dispatch({ type: ALLOCATION_EDIT_ROW, allocationToEdit: allocation });
        makeAllocationEditRequest(dispatch, siteId, accessToken);
    };
}

export function onAllocationEditResponseSuccess(licenseAllowances: ILicenseAllowance[]) {
    return {
        type: ALLOCATION_EDIT_ROW_SUCCESS,
        licenseAllowances
    };
}

export function onAllocationEditResponseError() {
    return {
        type: ALLOCATION_GET_ERROR,
        text: 'Error receiving data'
    };
}

export function makeAllocationEditRequest(dispatch: any, siteId: number, accessToken: string) {
    dispatch({ type: ALLOCATION_GET_REQUEST });
    return requestAllocationGet(siteId, accessToken).then(
        (success: ILicenseAllowance[]) => dispatch(onAllocationEditResponseSuccess(success)),
        error => dispatch(onAllocationEditResponseError())
    );
}

export function onCancelAddAllocation() {
    return (dispatch: any) => {
        dispatch({ type: ALLOCATION_CANCEL_REQUEST });
    };
}
export function onUpdateAllocation(allocation: ILicenseAllowance, accessToken: string) {
    return (dispatch: any) => {
        dispatch({ type: ALLOCATION_UPDATE_REQUEST, allocationToUpdate: allocation });
        makeAllocationPutRequest(dispatch, allocation, accessToken);
    };
}

export function makeAllocationPutRequest(dispatch: any, allocation: ILicenseAllowance, accessToken: string) {
    return requestAllocationPut(allocation, accessToken).then(
        (success: ILicenseAllowance[]) =>
            dispatch(onUpdateAllocationResponseSuccess(success, allocation)),
        error =>
            dispatch(onUpdateAllocationResponseError())
    );
}

export function onUpdateAllocationResponseSuccess(allocation: ILicenseAllowance[], allocationToUpdate: ILicenseAllowance) {
    return {
        type: ALLOCATION_UPDATE_SUCCESS,
        allocation,
        allocationToUpdate
    };
}

export function onUpdateAllocationResponseError() {
    return {
        type: ALLOCATION_UPDATE_ERROR,
        text: 'Error receiving data'
    };
}

export function onDeleteAllocation(allocation: ILicenseAllowance, siteId: number, accessToken: string) {
    return (dispatch: any) => {
        dispatch({ type: ALLOCATION_DELETE_REQUEST, allocationToDelete: allocation });
        makeAllocationDeleteRequest(dispatch, allocation, siteId, accessToken);
    };
}

export function makeAllocationDeleteRequest(dispatch: any, allocation: ILicenseAllowance, siteId: number, accessToken: string) {
    return requestAllocationDelete(allocation, accessToken).then(
        (success: ILicenseAllowance[]) => {
            dispatch(onDeleteAllocationResponseSuccess(success));
            dispatch(hardwareActionCreators.onServerGetRequest(siteId, accessToken));
        },
        (error: any) => dispatch(onDeleteAllocationResponseError())
    );
}

export function onDeleteAllocationResponseSuccess(allocation: ILicenseAllowance[]) {
    return {
        type: ALLOCATION_DELETE_SUCCESS,
        allocation
    };
}

export function onDeleteAllocationResponseError() {
    return {
        type: ALLOCATION_DELETE_ERROR,
        text: 'Error receiving data'
    };
}

export function clearErrorMessage() {
    return (dispatch: any) => {
        dispatch({ type: ALLOCATION_CLEAR_ERROR });
    };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/actionCreators/licenseAllowanceActionCreators.ts